import hackman_mock from '../mock_data/hackman';
// import standard_mock from '../mock_data/standard';

function extractData(response){
  var output = {
    name: response.kycData.full_name,
    email: response.person_details.current_email,
    account: response.account_details.account_type
  };
  if(response.account_details.company_name) output.company = response.account_details.company_name;
  
  return output;
}

export default function getResponse(setShowOverlay, setDetails, setError, setMessage) {
  if (!window.OrendaGetResponse || window.isSiteBuilder) {
    setTimeout(() => {
      setDetails(hackman_mock);
      setShowOverlay(false);
    }, 1000);
    return;
  }
  
  if(window.isAdminPortal){
    const urlParams = new window.URLSearchParams(window.location.search);
    const account_id = urlParams.get("account_id");
    if(!account_id) return;
    window.OrendaGetResponse({event_name: "getUserInfoForPortal", data: JSON.stringify({account_id})}, response => {
      if(response.error) return setError(true);
      if(response.message){
        setMessage(response.message);
        setShowOverlay(false);
        return;
      }
      setDetails(extractData(response));
      setShowOverlay(false);
      return;
    });
    return;
  }

  return window.OrendaGetResponse({ event_name: "getAccountInformation" }, (response) => {
    if (response.error) return setError(true);
    if(response.message) return setMessage(response.message);
    setDetails(extractData(response));
    setShowOverlay(false);
    return;
  });
}
